export default __webpack_public_path__ + "static/media/Moderate.67b2f378.svg";